import React, { Component } from "react";
import Tooltip from "@material-ui/core/Tooltip";

import "../report-styles/tableView.scss";

const generateWidthFromKeys = (keys) => {
  var obj = {};
  keys.map((k) => {
    obj = { ...obj, [k]: k.length / 2 };
  });

  return obj;
};
const generateSliceLengths = (keys) => {
  var obj = {};
  keys.map((k) => {
    obj = { ...obj, [k]: k.length > 17 ? k.length : 17 };
  });

  return obj;
};
export default class TableView extends React.Component {
  render() {
    const tableHeaders =
      this.props.data.length > 0 ? Object.keys(this.props.data[0]) : [];

    const tableCellsWidth = generateWidthFromKeys(tableHeaders);
    const cellSliceLength = generateSliceLengths(tableHeaders);
    console.log(tableCellsWidth);
    return (
      <div className="tableView-container">
        <div className="tableView-report-title">{this.props.report?.name}</div>

        <div className="overflow-mask">
          <div className="tableView-row row-header">
            {tableHeaders.map((header) => (
              <div
                className="table-cell table-header"
                key={header}
                style={{ width: `${tableCellsWidth[header]}em` }}
              >
                {header}
              </div>
            ))}
          </div>
          <div>
            {this.props.data.map((row) => (
              <div className="tableView-row">
                {tableHeaders.map((header, index) => {
                  return (
                    <div
                      className="table-cell"
                      key={header + row[header] + index}
                      style={{ width: `${tableCellsWidth[header]}em` }}
                    >
                      <Tooltip
                        arrow
                        title={
                          row[header] &&
                          row[header].length > cellSliceLength[header]
                            ? row[header]
                            : ""
                        }
                        placement="top-start"
                      >
                        <span>
                          {row[header] &&
                          row[header].length > cellSliceLength[header]
                            ? `${row[header].slice(
                                0,
                                cellSliceLength[header]
                              )} ...`
                            : row[header]}
                        </span>
                      </Tooltip>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
